"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepTwoOnlineFirstAppointment = void 0;
/* eslint-disable react-native/no-inline-styles */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../../atome");
const organisms_1 = require("../../../../organisms");
const UtilityFunctions_1 = require("../../../../../helper/UtilityFunctions");
const OnlineFirstAppointment_style_1 = require("../OnlineFirstAppointment.style");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
// @ts-ignore
function StepTwoOnlineFirstAppointment({ setCurrentPage, onlineFirstAppointmentInfo, setOnlineFirstAppointmentInfo, navigation, }) {
    const [selectedSlot, setSelectedSlot] = (0, react_1.useState)();
    const next = () => {
        if (selectedSlot) {
            setOnlineFirstAppointmentInfo({
                ...onlineFirstAppointmentInfo,
                doctorName: getDoctorName(selectedSlot.doctorId),
                doctorId: selectedSlot.doctorId,
                selectedSlot: selectedSlot,
            });
            let reducerType = {
                type: '[UPDATE]',
                payload: {
                    onlineFirstAppointmentIndex: 3,
                },
            };
            setCurrentPage(reducerType);
        }
    };
    function sortDates(array) {
        return array.sort((a, b) => {
            if (new Date(a.start) < new Date(b.start)) {
                return -1;
            }
            if (new Date(a.start) > new Date(b.start)) {
                return 1;
            }
            return 0;
        });
    }
    const getDoctorName = (id) => {
        let name = '';
        let title = '';
        onlineFirstAppointmentInfo.doctors.map((item) => {
            if (item.id === parseInt(id)) {
                title = item.title
                    ? item.title === 'professor'
                        ? 'Prof.'
                        : 'Dr.'
                    : '';
                name = title + ' ' + item.firstname + ' ' + item.lastname;
            }
        });
        return name;
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OnlineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_1.Icon, { icon: "calendarWithDays", size: 70, color: "#3db384" })),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.headerTitle, OnlineFirstAppointment_style_1.styles.greenText] }, "Wann soll Ihr Online Erstgespr\u00E4ch stattfinden?")),
                react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.timeContainer] },
                    react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.timeDiv, { backgroundColor: '#00000010' }] },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row] },
                            react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.marginTop5, OnlineFirstAppointment_style_1.styles.timeDivText] },
                                (0, UtilityFunctions_1.toDay)(onlineFirstAppointmentInfo.selectedDate.getDay()),
                                ' ',
                                new Date(onlineFirstAppointmentInfo.selectedDate).toLocaleString('de-DE', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                }))),
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginTop20] },
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.greenLinkText], onPress: () => {
                                        let reducerType = {
                                            type: '[UPDATE]',
                                            payload: { onlineFirstAppointmentIndex: 1 },
                                        };
                                        setCurrentPage(reducerType);
                                        return;
                                    } }, "Datum \u00E4ndern")))),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(atome_1.Text, { style: [
                                OnlineFirstAppointment_style_1.styles.timeDivText,
                                GlobalStyles_1.globalStyles.marginTop30,
                                GlobalStyles_1.globalStyles.marginBottom10,
                                Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.paddingHorizontal15,
                            ] }, "Bitte w\u00E4hlen Sie eine Uhrzeit f\u00FCr Ihren Termin."),
                        react_1.default.createElement(react_native_1.View, null, sortDates(onlineFirstAppointmentInfo.doctorSlots).map((slot, i) => (react_1.default.createElement(react_native_1.View, { key: i }, selectedSlot &&
                            slot.start === selectedSlot.start &&
                            slot.doctorId === selectedSlot.doctorId ? (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setSelectedSlot(undefined), style: [
                                OnlineFirstAppointment_style_1.styles.timeDiv,
                                OnlineFirstAppointment_style_1.styles.timeDivClicked,
                                { backgroundColor: '#3DB384', marginVertical: 5 },
                            ] },
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginBottom20,
                                ] },
                                react_1.default.createElement(atome_1.Text, { style: [
                                        GlobalStyles_1.globalStyles.marginTop5,
                                        OnlineFirstAppointment_style_1.styles.timeDivTextClicked,
                                    ] },
                                    new Date(slot.start).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    }),
                                    ' ',
                                    "-",
                                    ' ',
                                    new Date(slot.end).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    }),
                                    ' ',
                                    "Uhr")),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginBottom20,
                                ] },
                                react_1.default.createElement(react_native_1.View, { style: { marginTop: 2, marginRight: 10 } },
                                    react_1.default.createElement(atome_1.Icon, { icon: "user", size: 16, color: "white" })),
                                react_1.default.createElement(atome_1.Text, { style: [{ color: 'white' }] },
                                    "Arzt: ",
                                    getDoctorName(slot.doctorId))),
                            react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.buttonContainer },
                                react_1.default.createElement(react_native_1.Pressable, { style: OnlineFirstAppointment_style_1.styles.button, onPress: next },
                                    react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.buttonText] }, "Termin buchen"))))) : (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setSelectedSlot(slot), style: [
                                OnlineFirstAppointment_style_1.styles.timeDiv,
                                { marginVertical: 5, backgroundColor: 'white' },
                            ] },
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginBottom20,
                                ] },
                                react_1.default.createElement(atome_1.Text, { style: [
                                        GlobalStyles_1.globalStyles.marginTop5,
                                        OnlineFirstAppointment_style_1.styles.timeDivText,
                                    ] },
                                    new Date(slot.start).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    }),
                                    ' ',
                                    "-",
                                    ' ',
                                    new Date(slot.end).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    }),
                                    ' ',
                                    "Uhr")),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginBottom20,
                                ] },
                                react_1.default.createElement(react_native_1.View, { style: { marginTop: 2, marginRight: 10 } },
                                    react_1.default.createElement(atome_1.Icon, { icon: "user", size: 16, color: "black" })),
                                react_1.default.createElement(atome_1.Text, null,
                                    "Arzt: ",
                                    getDoctorName(slot.doctorId)))))))))))))));
}
exports.StepTwoOnlineFirstAppointment = StepTwoOnlineFirstAppointment;
